import script from "./TopNavbarUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopNavbarUser.vue?vue&type=script&lang=ts&setup=true"

import "./TopNavbarUser.vue?vue&type=style&index=0&id=b9098b46&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9098b46"]])

export default __exports__